import _extends from '@babel/runtime/helpers/extends';
import React__default, { memo, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { a as angleRight } from '../LocalModules/storm-ui-icons/dist/esm/classicIcons-Dl_q4l5f--kL9Y5b9.js';
import { I as Icon } from '../Icon/Icon-BVCquTfq.js';

const ArrowButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40020072__sc-1d1l5l5-0"
})(["&& > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}", "}[dir=\"rtl\"] && > svg{@media (prefers-reduced-motion:no-preference){transition:transform 150ms ease-in-out;}/*! @noflip */ transform:rotate(180deg);", "}"], ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]), ({
  $opened
}) => $opened && css(["/*! @noflip */ transform:rotate(90deg);"]));
const StyledArrowButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40020072__sc-1d1l5l5-1"
})(["color:", ";background:none;border:none;cursor:pointer;width:", ";height:", ";align-self:center;padding:0;display:flex;margin:0;justify-content:center;align-items:center;:hover{background:none;}"], ({
  theme
}) => theme.icon.color.default, ({
  theme
}) => theme.controls.height.xsmall.default, ({
  theme
}) => theme.controls.height.xsmall.default);
const ArrowButtonSpacer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40020072__sc-1d1l5l5-2"
})(["flex:0 0 auto;width:", ";"], ({
  theme
}) => theme.controls.height.xsmall.default);
const NoArrowSpacer = ({
  displayAll,
  hasSiblingWithArrowButton
}) => {
  if (displayAll || !hasSiblingWithArrowButton) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(ArrowButtonSpacer, null);
};
function ArrowButton({
  item,
  onArrowClick,
  opened,
  ariaLabel,
  taktId,
  taktValue
}) {
  const handleArrowClick = useCallback(() => onArrowClick(item), [item, onArrowClick]);
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('tree')
  });
  const {
    children,
    renderLabel,
    ...rest
  } = item;
  return /*#__PURE__*/React__default.createElement(StyledArrowButton, _extends({
    "data-test-id": `option-expander-${item.label}`,
    onClick: handleArrowClick,
    "aria-expanded": opened,
    "aria-label": ariaLabel
  }, getDataTaktAttributes({
    taktIdSuffix: `${item.id.toString()}-arrow`,
    taktValue,
    contextOnlyTaktValues: {
      item: rest
    }
  })), /*#__PURE__*/React__default.createElement(ArrowButtonIcon, {
    type: angleRight,
    isClickTarget: true,
    $opened: opened
  }));
}
var ArrowButton$1 = /*#__PURE__*/memo(ArrowButton);

export { ArrowButton$1 as A, NoArrowSpacer as N };
//# sourceMappingURL=ArrowButton-DD8mGeoG.js.map
